import React from "react";
import SettingsModal from "../components/modals/settings";
import axios from "../utils/axiosConfig";
import ModalBaseSm from "./../components/modals/modal-base-sm";
import FormUpdatePassword from "../components/formsSolicitudes/formUpdatePassword";
import "../Pages/Css/navbarPrincipal.css";

import {
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Button,
} from "reactstrap";

const server = localStorage.getItem("server");
const userName = localStorage.getItem("username");

class Barra extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openModal: false,
      openModalChangePassword: false,

      // responsive
      isMobile: window.matchMedia("(max-width: 768px)").matches,
      offcanvasUser: false,
    };

    this.logout = this.logout.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openModalChangePassword = this.openModalChangePassword.bind(this);
    this.closeModalChangePassword = this.closeModalChangePassword.bind(this);

    this.handleResize = this.handleResize.bind(this);
    this.toggleOffcanvasUser = this.toggleOffcanvasUser.bind(this);
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize() {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    this.setState((prev) => {
      const next = { isMobile };

      // si pasa a desktop, cerramos el offcanvas
      if (!isMobile && prev.offcanvasUser) next.offcanvasUser = false;

      return next;
    });
  }

  toggleOffcanvasUser() {
    this.setState((prev) => ({ offcanvasUser: !prev.offcanvasUser }));
  }

  openOffcanvasUser = () => {
    this.setState({ offcanvasUser: true });
  };

  closeOffcanvasUser = () => {
    this.setState({ offcanvasUser: false });
  };

  openModal() {
    this.setState({ openModal: true });
  }

  openModalChangePassword() {
    this.setState({ openModalChangePassword: true });
  }

  closeModalChangePassword() {
    this.setState({ openModalChangePassword: false });
  }

  closeModal() {
    this.setState({ openModal: false });
  }

  logout() {
    axios
      .get(process.env.REACT_APP_SERVER + "/logout", {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then(() => {
        localStorage.removeItem("tkn");
        localStorage.removeItem("username");
        localStorage.removeItem("companyId");
        localStorage.removeItem("server");
        localStorage.removeItem("isRefreshIntervalActive");
        localStorage.removeItem("project");
        localStorage.removeItem("idFilterSelected");
        localStorage.removeItem("arrayFilters");
        sessionStorage.removeItem("trafico:arrayFilters");
        localStorage.removeItem("global_expansion_state");
        localStorage.removeItem("search");
        sessionStorage.removeItem("trafico:search");
        localStorage.removeItem("active_streams_v1");
        sessionStorage.removeItem("active_streams_v1");

        Object.keys(localStorage).forEach((key) => {
          if (key.endsWith("_expanded")) localStorage.removeItem(key);
        });

        window.location = "/login";
      });
  }

  render() {
    return (
      <>
        <nav
          className="layout-navbar container-fluid navbar navbar-expand-xl align-items-center custom-navbar-admin platform-responsive-navbar"
          id="layout-navbar"
        >
          {typeof this.props.onToggleNavigation === "function" && (
            <button
              type="button"
              className="platform-navbar-menu-toggle"
              onClick={this.props.onToggleNavigation}
              aria-label="Abrir menú de navegación"
              title="Menú de navegación"
            >
              <i className="bx bx-menu" aria-hidden="true"></i>
            </button>
          )}
          <a href="/principal" className="app-brand-link">
            <img alt="" className="style21" src="./Cargotronics.png" height="80" />
          </a>
          {/* V.G.1 */}
          <div className="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
            <ul className="navbar-nav flex-row align-items-center ms-auto navbar-actions">
              {/* USERNAME SOLO DESKTOP */}
              <li className="nav-item d-none d-lg-block">
                <span className="fw-semibold" style={{ marginRight: 6 }}>
                  {userName || "John Doe"}
                </span>
              </li>

              {/* AVATAR */}
              <li className="nav-item navbar-dropdown dropdown-user dropdown nav-avatar">
                {this.state.isMobile ? (
                  <button
                    type="button"
                    className="btn-reset"
                    onClick={this.openOffcanvasUser}
                    aria-label="Abrir menú de usuario"
                  >
                    <img
                      src="../assets/img/avatars/1.png"
                      alt="avatar"
                      className="avatar-img"
                    />
                  </button>
                ) : (
                  <>
                    <a className="nav-link dropdown-toggle hide-arrow" data-bs-toggle="dropdown" href="#">
                      <img
                        src="../assets/img/avatars/1.png"
                        alt="avatar"
                        className="avatar-img"
                      />
                    </a>

                    <ul className="dropdown-menu dropdown-menu-end">
                      <li>
                        <div className="dropdown-item">
                          <div className="d-flex">
                            <div className="flex-shrink-0 me-3" id="AvatarReponsive">
                              <div className="avatar avatar-online">
                                <img src="../assets/img/avatars/1.png" alt="" className="w-px-40 h-auto rounded-circle" />
                              </div>
                            </div>
                            <div className="flex-grow-1">
                              <span
                                className="fw-semibold d-block text-wrap"
                                style={{ maxWidth: 150, wordBreak: "break-all", whiteSpace: "normal" }}
                              >
                                {userName || "John Doe"}
                              </span>
                              <small className="text-muted">Admin</small>
                            </div>
                          </div>
                        </div>
                      </li>

                      <li><div className="dropdown-divider"></div></li>

                      <li>
                        <a className="dropdown-item" href="/myprofile">
                          <i className="bx bx-user me-2"></i>
                          <span className="align-middle">My Profile</span>
                        </a>
                      </li>

                      <li>
                        <button
                          type="button"
                          className="dropdown-item"
                          onClick={this.openModal}
                          data-bs-target="#ModalSettings"
                          data-bs-toggle="modal"
                        >
                          <i className="bx bx-cog me-2"></i>
                          <span className="align-middle">Settings</span>
                        </button>
                      </li>

                      <li>
                        <button
                          type="button"
                          className="dropdown-item"
                          onClick={this.openModalChangePassword}
                        >
                          <i className="bx bx-lock me-2"></i>
                          <span className="align-middle">Cambiar contraseña</span>
                        </button>
                      </li>

                      <li><div className="dropdown-divider"></div></li>

                      <li>
                        <button type="button" className="dropdown-item" onClick={this.logout}>
                          <i className="bx bx-power-off me-2"></i>
                          <span className="align-middle">Log Out</span>
                        </button>
                      </li>
                    </ul>
                  </>
                )}
              </li>
            </ul>
          </div>
        </nav>

        {/* ✅ OFFCANVAS USER (MOBILE) */}
        <Offcanvas
          isOpen={this.state.offcanvasUser}
          toggle={this.toggleOffcanvasUser}
          direction="end"
          fade={false}
          className="barra-responsive-offcanvas"
          style={{ width: "100vw", maxWidth: "100vw" }}
        >
          <OffcanvasHeader toggle={this.toggleOffcanvasUser}>
            Mi cuenta
          </OffcanvasHeader>

          <OffcanvasBody>
            <div className="text-center mb-4">
              <img
                src="../assets/img/avatars/1.png"
                alt="avatar"
                className="rounded-circle mb-2"
                width="72"
              />
              <h6 className="mb-0">{userName}</h6>
              <small className="text-muted">Admin</small>
            </div>

            <Button
              color="light"
              className="w-100 mb-2 text-start"
              onClick={() => (window.location.href = "/myprofile")}
            >
              <i className="bx bx-user me-2"></i>
              Mi perfil
            </Button>

            <Button
              color="light"
              className="w-100 mb-2 text-start"
              onClick={this.openModal}
              data-bs-toggle="modal"
              data-bs-target="#ModalSettings"
            >
              <i className="bx bx-cog me-2"></i>
              Configuración
            </Button>

            <Button
              color="light"
              className="w-100 mb-2 text-start"
              onClick={this.openModalChangePassword}
            >
              <i className="bx bx-lock me-2"></i>
              Cambiar contraseña
            </Button>

            <hr />

            <Button
              color="light"
              className="w-100 text-start"
              onClick={this.logout}
            >
              <i className="bx bx-power-off me-2"></i>
              Cerrar sesión
            </Button>
          </OffcanvasBody>
        </Offcanvas>

        {/* Modals */}
        <div className="modal fade" id="settingsModal" data-bs-backdrop="static" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <p>Set</p>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <SettingsModal isOpen={this.state.openModal} onClose={this.closeModal} />
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade" id="ModalSettings" data-bs-backdrop="static" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <form className="modal-content" id="ModalSettings">
              <div className="modal-header">
                <h5 className="modal-title" id="backDropModalTitle">
                  Base de datos: {server === "Prod" ? "Producción" : "Pruebas"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={this.closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <SettingsModal isOpen={this.state.openModal} onClose={this.closeModal} />
                </div>
              </div>
            </form>
          </div>
        </div>

        <ModalBaseSm
          isOpen={this.state.openModalChangePassword}
          title={"Cambiar contraseña"}
          onClose={this.closeModalChangePassword}
          childComponent={<FormUpdatePassword onClose={this.closeModalChangePassword} />}
        />
      </>
    );
  }
}

export default Barra;
